import Root from "../layouts/Root";
import IconText from "../components/IconText";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import LinkedText from "../components/LinkedText";

export default function Blog() {

    const rightContent = (
        <div>
            <h1><IconText icon={faCalendar} text={"2026"}></IconText></h1>
            <h2>May</h2>
            <LinkedText to={"/blog/my-agentic-coding-setup"}
                        text={"My Agentic Coding Setup"}>
            </LinkedText>
            <h1><IconText icon={faCalendar} text={"2025"}></IconText></h1>
            <h2>November</h2>
            <LinkedText to={"/blog/how-i-converted-my-react-django-setup-into-a-static-github-pages-site"}
                        text={"How I Converted My React + Django Setup Into a Static GitHub Pages Site"}>
            </LinkedText>
            
            <h1><IconText icon={faCalendar} text={"2024"}></IconText></h1>
            <h2>November</h2>
            <LinkedText to={"/blog/get-to-the-point"} text={"Get to the Point"}></LinkedText>
            
            <h2>May</h2>
            <LinkedText to={"/blog/google-foobar-challenge"} text={"Google Foobar Challenge Solutions with Animations"}></LinkedText>
            
            <h1><IconText icon={faCalendar} text={"2022"}></IconText></h1>
            <h2>June</h2>
            <p><em>My graduation thesis</em></p>
            <LinkedText to={"/blog/mathematical-artificial-intelligence"} text={"Mathematical Artificial Intelligence"}></LinkedText>
        </div>
    )
    return (
        <div className="blog-page">
            <Root rightContent={rightContent}/>
        </div>
    )
}
